import { render, staticRenderFns } from "./diveshopList.vue?vue&type=template&id=7dd6cb9f&scoped=true&"
import script from "./diveshopList.vue?vue&type=script&lang=js&"
export * from "./diveshopList.vue?vue&type=script&lang=js&"
import style0 from "./diveshopList.vue?vue&type=style&index=0&id=7dd6cb9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd6cb9f",
  null
  
)

export default component.exports